
function userReducer(state = {}, action = {} as any) {

  switch (action.type) {
    case "UPDATE_USER":
      return {
        ...state,
        ...action.payload
      };
      // For now added delete user for sonarFix
    case "DELETE_USER":
      return {
        ...state
      };
    default:
      return state;
  }
}

export default userReducer;
